import { render, staticRenderFns } from "./VaimoInformationPleats.vue?vue&type=template&id=35e09452&"
import script from "./VaimoInformationPleats.vue?vue&type=script&lang=ts&"
export * from "./VaimoInformationPleats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports